// extracted by mini-css-extract-plugin
export default {"mn-marking":"index_mn-marking__2V2IR","mn-marking-list-popover":"index_mn-marking-list-popover__hJy9d"};